import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useMutation, useQuery } from 'react-apollo-hooks'
import styled from 'react-emotion'
import getText from '../strings'
import { ga } from '../../application'
import GuideOnlineMessage from './GuideOnlineMessage'
import { colors } from '../../styles'
import { getGuideOnlineMessages } from '../queries'
import { sendGuideOnlineMessage } from '../mutations'

const Chat = styled('div')`
  height: 400px;
  overflow-y: auto;
  padding: 12px 0;

  @media (min-width: 768px) {
    height: 600px;
  }
`

const MessageBar = styled('form')`
  background-color: ${colors.tui_grey_25};
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 -10px -10px;
  padding: 6px;

  @media (min-width: 768px) {
    margin: 0 -20px -20px;
  }
`

const MessageInput = styled('input')`
  flex-basis: 50%;
  width: 50%;
`

const GuideOnline = ({ bookingNumber }) => {
  const [messageText, setMessageText] = useState('')
  const [isSending, setIsSending] = useState(false)
  const endOfChatRef = useRef(null)
  const { isLoading, data, refetch } = useQuery(
    getGuideOnlineMessages(bookingNumber)
  )
  const sendMessage = useMutation(sendGuideOnlineMessage)

  useEffect(() => {
    console.log('Data: ', data)
    endOfChatRef.current.scrollIntoView()
  }, [data])

  const handleChange = (e) => {
    setMessageText(e.target.value)
  }

  const handleSubmitMessage = async (e) => {
    e.preventDefault()
    ga.buttonClick('guideonline-sendmessage')
    setIsSending(true)
    try {
      await sendMessage({
        variables: { bookingNumber, text: messageText },
      })
      refetch()
      setMessageText('')
      setIsSending(false)
    } catch (e) {
      console.log('ERROR!', e)
      setIsSending(false)
    }
  }

  return (
    <Fragment>
      <h2>{getText('selfservice', 'askTheGuides', 'title')}</h2>
      <Chat>
        {data &&
          data.booking &&
          data.booking.guideOnline &&
          data.booking.guideOnline.messages.map((message, index) => (
            <GuideOnlineMessage
              message={message}
              key={index}
            ></GuideOnlineMessage>
          ))}
        <div ref={endOfChatRef}></div>
      </Chat>
      <MessageBar onSubmit={handleSubmitMessage}>
        <MessageInput
          onChange={handleChange}
          value={messageText}
          placeholder={getText('selfservice', 'askTheGuides', 'placeholder')}
          disabled={isLoading || isSending}
        />
      </MessageBar>
    </Fragment>
  )
}

export default GuideOnline
